export default {
    keyfobs_main_title: 'DriverID Tag',
    keyfobs_main_add_driver_key: 'Add DriverID Tag',
    keyfobs_main_model: 'Model',
    keyfobs_main_account: 'Account',
    keyfobs_main_keyfob_model: 'KeyFob Model',
    keyfobs_main_move: 'Move to another account',
    keyfobs_main_unassign: 'Unassign Drivers',
};
